export const AMEND_SUPPORT_REASON = {
  DEFAULT_API_FAILURE_AMEND: 'DEFAULT_API_FAILURE_AMEND',
  DEFAULT_FAILURE_AMEND: 'DEFAULT_FAILURE_AMEND',
  GDS_INTL_AMEND: 'GDS_INTL_AMEND',
  GDS_INTL_FREE_AMEND: 'GDS_INTL_FREE_AMEND',
  SPECIAL_RT_ERROR_AMEND: 'SPECIAL_RT_ERROR_AMEND',
  PARTIAL_PAX_AMENDMENT: 'PARTIAL_PAX_AMENDMENT',
} as const

export const AMEND_GENERIC_REQUEST_RECEIVED_SUBSTR = 'received your request'

export const AMEND_EXACT_GENERIC_FULFILLMENT_MSG =
  'We have received your request. A Cleartripper will contact you shortly.' as const

export const AMEND_SUPPORT_COMPLAINT = {
  DEFAULT_API_FAILURE: 'Default failure',
  GDS_INTL_ONLINE: 'GAL trip - cant be amended online',
  GDS_INTL_TECH: 'Tech issues - cant be amended online',
  OFFER_BLOCK: 'Offer / promotional booking — online date change blocked',
  PARTIAL_RT: 'Partial amendment',
  PARTIAL_PAX: 'GDS partial pax amendment',
} as const
